import { createSlice } from "@reduxjs/toolkit";
import { CollaboratorProps } from "./Collaborator";

const initialState: CollaboratorProps.State = {
  collaboratorList: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  remainingCount: 0,
  getCollaborators_API_STATUS: "idle",
};
const slice = createSlice({
  name: "collaborator",
  initialState,
  reducers: {
    setCollaborators: (state, action: CollaboratorProps.setCollaborators) => {
      const { data, page, pageSize, totalCount, totalPages, remainingCount } =
        action.payload;
      state.collaboratorList =
        page === 1 ? data : [...state.collaboratorList, ...data];
      state.page = page;
      state.pageSize = pageSize;
      state.totalCount = totalCount;
      state.totalPages = totalPages;
      state.remainingCount = remainingCount;
    },
    setGetCollaborators_API_STATUS: (
      state,
      action: CollaboratorProps.setGetCollaborators_API_STATUS
    ) => {
      state.getCollaborators_API_STATUS = action.payload;
    },
    reset: () => initialState,
  },
});

export const collaboratorActions = slice.actions;
export const collaboratorReducer = slice.reducer;
